(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-bar')) {
    customElements.define(
      'marquee-bar',
      class MarqueeBar extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.marquee__track');
          this.group = this.querySelector('.marquee__group');
          if (!this.track || !this.group || !this.group.children.length) return;

          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onMotionChange = () => this.build();
          this.motion.addEventListener('change', this.onMotionChange);

          this.lastWidth = 0;
          this.resizeObserver = new ResizeObserver(() => {
            if (this.offsetWidth === this.lastWidth) return;
            this.lastWidth = this.offsetWidth;
            this.build();
          });
          this.resizeObserver.observe(this);

          if (document.fonts?.ready) document.fonts.ready.then(() => this.build());
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.motion?.removeEventListener('change', this.onMotionChange);
        }

        build() {
          this.track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());
          this.classList.remove('is-running');

          if (this.motion.matches) return;

          this.classList.add('is-running');
          const groupWidth = this.group.getBoundingClientRect().width;
          if (!groupWidth) {
            this.classList.remove('is-running');
            return;
          }

          const copies = Math.ceil(this.offsetWidth / groupWidth) + 1;
          for (let i = 0; i < copies; i += 1) {
            const clone = this.group.cloneNode(true);
            clone.setAttribute('data-marquee-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            clone.querySelectorAll('*').forEach((el) => {
              [...el.attributes]
                .filter((attr) => attr.name.startsWith('data-shopify'))
                .forEach((attr) => el.removeAttribute(attr.name));
            });
            this.track.appendChild(clone);
          }

          const speed = Number(this.dataset.speed) || 32;
          this.style.setProperty('--marquee-distance', `${-groupWidth}px`);
          this.style.setProperty('--marquee-duration', `${(groupWidth / speed).toFixed(2)}s`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-cart-dialog]');
          this.body = this.querySelector('[data-cart-drawer-body]');
          this.sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '') || 'cart-drawer';

          this.onLinkClick = (event) => {
            const link = event.target.closest('#HeaderCartLink');
            if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            this.opener = link;
            this.open();
          };
          document.addEventListener('click', this.onLinkClick);

          this.onAdded = async () => {
            this.opener = document.activeElement;
            await this.refresh();
            this.open();
          };
          document.addEventListener('cart:updated', this.onAdded);

          // A change made on the /cart page: bring the drawer's copy up to date quietly.
          this.onChanged = (event) => {
            if (event.detail?.source !== this.sectionId) this.refresh();
          };
          document.addEventListener('cart:changed', this.onChanged);

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-cart-close]')) this.close();
          });
          this.dialog.addEventListener('close', () => this.onClosed());
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onLinkClick);
          document.removeEventListener('cart:updated', this.onAdded);
          document.removeEventListener('cart:changed', this.onChanged);
        }

        async refresh() {
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${this.sectionId}`);
            const data = await response.json();
            const fresh = new DOMParser().parseFromString(data[this.sectionId], 'text/html').querySelector('[data-cart-drawer-body]');
            if (fresh) this.body.innerHTML = fresh.innerHTML;
          } catch (error) {
            // Keep the current contents; the cart page link still works.
          }
        }

        open() {
          if (this.dialog.open) return;
          this.dialog.showModal();
          // Lines settle in just behind the slide; a class, so re-rendered lines (quantity changes) never replay it.
          this.dialog.classList.add('is-opening');
          window.setTimeout(() => this.dialog.classList.remove('is-opening'), 900);
          document.documentElement.classList.add('is-scroll-locked');
          document.getElementById('HeaderCartLink')?.setAttribute('aria-expanded', 'true');
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        onClosed() {
          document.documentElement.classList.remove('is-scroll-locked');
          document.getElementById('HeaderCartLink')?.setAttribute('aria-expanded', 'false');
          if (this.opener && this.opener.isConnected && this.opener.checkVisibility?.()) this.opener.focus();
          this.opener = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // After a post, bring the result into view and to screen readers' attention.
    const result = document.querySelector('[data-contact-success], [data-contact-errors]');
    if (!result) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    result.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    result.focus({ preventScroll: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product')) {
    customElements.define(
      'featured-product',
      class FeaturedProduct extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.showSlide(Number(thumb.dataset.galleryThumb)))
          );
        }

        showSlide(index) {
          this.slides.forEach((slide, i) => {
            const active = i === index;
            slide.classList.toggle('is-active', active);
            if (active) {
              slide.removeAttribute('aria-hidden');
            } else {
              slide.setAttribute('aria-hidden', 'true');
            }
          });
          this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const clamp = (v) => Math.min(1, Math.max(0, v));
    const seg = (t, a, b) => clamp((t - a) / (b - a));

    // Botanical order: stems, then leaves, then flowers; a flower's fill
    // arrives only once its outline is complete; florets last.
    const stages = (t) => {
      const f3 = seg(t, 0.5, 0.72);
      const f2 = seg(t, 0.55, 0.8);
      const f1 = seg(t, 0.6, 0.86);
      return {
        '--d-stem': seg(t, 0, 0.3),
        '--d-rib': seg(t, 0.2, 0.42),
        '--d-leaflet': seg(t, 0.28, 0.58),
        '--d-f3': f3,
        '--d-f2': f2,
        '--d-f1': f1,
        '--fill-3': seg(t, 0.72, 0.78),
        '--fill-2': seg(t, 0.8, 0.86),
        '--fill-1': seg(t, 0.86, 0.92),
        '--d-floret': seg(t, 0.9, 1),
      };
    };

    // Split the quote into rendered lines: a visual copy (aria-hidden) built
    // from word spans grouped by their offsetTop. The real paragraph stays
    // in place, visually hidden, for screen readers.
    const splitLines = (quote) => {
      const source = quote.querySelector('[data-quote]');
      if (!source) return;
      quote.querySelector('.founder__lines')?.remove();
      source.classList.remove('visually-hidden');

      const copy = source.cloneNode(true);
      copy.removeAttribute('data-quote');
      copy.className = 'founder__lines';
      copy.setAttribute('aria-hidden', 'true');
      source.after(copy);

      const words = [];
      let spaceBefore = false;
      const walker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(' '));
            spaceBefore = true;
            return;
          }
          const word = document.createElement('span');
          word.textContent = part;
          word.dataset.em = node.parentElement.closest('em, i') ? '1' : '';
          word.dataset.space = spaceBefore ? '1' : '';
          spaceBefore = false;
          words.push(word);
          fragment.appendChild(word);
        });
        node.replaceWith(fragment);
      });
      source.classList.add('visually-hidden');

      const lines = [];
      let top = null;
      words.forEach((word) => {
        const y = Math.round(word.offsetTop);
        if (top === null || Math.abs(y - top) > 4) {
          lines.push([]);
          top = y;
        }
        lines[lines.length - 1].push(word);
      });

      copy.textContent = '';
      lines.forEach((lineWords, i) => {
        const line = document.createElement('span');
        line.className = 'founder__line';
        const inner = document.createElement('span');
        inner.className = 'founder__line-inner';
        inner.style.setProperty('--i', i);
        lineWords.forEach((word, j) => {
          if (j > 0 && word.dataset.space) inner.appendChild(document.createTextNode(' '));
          const text = document.createElement('span');
          text.textContent = word.textContent;
          if (word.dataset.em) {
            const em = document.createElement('em');
            em.appendChild(text);
            inner.appendChild(em);
          } else {
            inner.appendChild(text);
          }
        });
        line.appendChild(inner);
        copy.appendChild(line);
      });
    };

    const setup = (root = document) => {
      root.querySelectorAll('.founder').forEach((section) => {
        if (section.dataset.founderReady) return;
        section.dataset.founderReady = 'true';

        const quote = section.querySelector('.founder__quote');
        const art = section.querySelector('.founder__sprig-art');

        if (reduced.matches || !('IntersectionObserver' in window)) {
          section.classList.add('is-static', 'is-in');
          return;
        }

        if (quote) {
          // Split once, after fonts load (line breaks depend on them); again only on resize.
          const resplit = () => splitLines(quote);
          if (document.fonts?.ready) document.fonts.ready.then(resplit);
          else resplit();
          let width = window.innerWidth;
          let timer;
          window.addEventListener('resize', () => {
            if (window.innerWidth === width) return;
            width = window.innerWidth;
            clearTimeout(timer);
            timer = setTimeout(resplit, 150);
          });
        }

        // Values go on the snippet's part groups, and only when they change,
        // so a frame restyles one or two groups instead of all 277 paths.
        const groupVars = {
          stems: ['--d-stem'],
          leaves: ['--d-rib', '--d-leaflet'],
          bud: ['--d-f3', '--fill-3'],
          'flower-2': ['--d-f2', '--fill-2', '--d-floret'],
          'flower-1': ['--d-f1', '--fill-1', '--d-floret'],
        };
        // One SVG per group, stacked in the original order (see the CSS).
        const layers = [];
        if (art) {
          art.querySelectorAll(':scope > [data-group]').forEach((group, i) => {
            if (i === 0) {
              layers.push(art);
              return;
            }
            const layer = art.cloneNode(false);
            layer.appendChild(group);
            layers[layers.length - 1].after(layer);
            layers.push(layer);
          });
          art.parentElement.classList.add('is-split');
        }
        const groups = art
          ? Object.keys(groupVars).map((name) => ({ el: section.querySelector(`.founder__sprig [data-group="${name}"]`), keys: groupVars[name], last: {} }))
          : [];
        const paint = (t) => {
          if (!art) return;
          const values = stages(t);
          groups.forEach((group) => {
            if (!group.el) return;
            group.keys.forEach((key) => {
              const value = Math.round(values[key] * 250) / 250;
              if (group.last[key] === value) return;
              group.last[key] = value;
              group.el.style.setProperty(key, value);
            });
          });
        };

        if (art) {
          layers.forEach((layer) => layer.classList.add('is-drawing'));
          paint(0);
        }

        // Timed draw, about 2.2s, the same on every screen size, staggered by
        // part group (see stages). Nothing is scroll-linked: it plays once
        // when the section trigger fires. If the section leaves the viewport
        // before it finishes, it snaps to fully drawn and the timer stops, so
        // the draw never runs while the reader scrolls past.
        const playTimed = () => {
          const start = performance.now();
          const duration = 2200;
          let frame = 0;
          let exitObserver = null;
          const finish = () => {
            cancelAnimationFrame(frame);
            exitObserver?.disconnect();
            paint(1);
          };
          const tick = (now) => {
            const t = clamp((now - start) / duration);
            if (t >= 1) {
              finish();
              return;
            }
            paint(1 - Math.pow(1 - t, 2));
            frame = requestAnimationFrame(tick);
          };
          frame = requestAnimationFrame(tick);
          exitObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => !entry.isIntersecting)) finish();
          });
          exitObserver.observe(section);
        };

        // One trigger for the whole moment: mark fades in, lines rise, sprig draws.
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            section.classList.add('is-in');
            if (art) playTimed();
            observer.disconnect();
          },
          { rootMargin: '0px 0px -30% 0px' }
        );
        observer.observe(section);
      });
    };

    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founding-band"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Place the back sheet's notches so that, after its offset and tilt,
    // they land exactly on the front sheet's notches.
    const toPx = (value) => parseFloat(value) || 0;

    const align = (ticket) => {
      const back = ticket.querySelector('[data-back]');
      const paper = back?.firstElementChild;
      const main = ticket.querySelector('.founding__main');
      if (!paper || !main || !ticket.classList.contains('founding__ticket--stub')) return;

      const styles = getComputedStyle(ticket.closest('.founding'));
      const tilt = (toPx(styles.getPropertyValue('--back-tilt')) * Math.PI) / 180;
      const shift = toPx(styles.getPropertyValue('--back-shift'));
      const w = back.offsetWidth;
      const h = back.offsetHeight;
      const side = main.offsetWidth < w - 1;

      // Front notch centres in the ticket's (unrotated) box.
      const targets = side
        ? [[main.offsetWidth, 0], [main.offsetWidth, h]]
        : [[0, main.offsetHeight], [w, main.offsetHeight]];

      // Invert translate(-shift, shift) rotate(tilt) about the sheet's centre.
      const cos = Math.cos(-tilt);
      const sin = Math.sin(-tilt);
      targets.forEach(([fx, fy], i) => {
        ticket.style.setProperty(`--f${i + 1}x`, `${fx}px`);
        ticket.style.setProperty(`--f${i + 1}y`, `${fy}px`);
        const dx = fx - w / 2 + shift;
        const dy = fy - h / 2 - shift;
        const x = w / 2 + dx * cos - dy * sin;
        const y = h / 2 + dx * sin + dy * cos;
        back.style.setProperty(`--n${i + 1}x`, `${x.toFixed(2)}px`);
        back.style.setProperty(`--n${i + 1}y`, `${y.toFixed(2)}px`);
      });
    };

    const setup = (root = document) => {
      root.querySelectorAll('.founding__ticket').forEach((ticket) => {
        if (ticket.dataset.notchReady) return;
        ticket.dataset.notchReady = 'true';
        align(ticket);
        if ('ResizeObserver' in window) new ResizeObserver(() => align(ticket)).observe(ticket);
        window.addEventListener('resize', () => align(ticket));
      });
    };

    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('menu-drawer')) {
    customElements.define(
      'menu-drawer',
      class MenuDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.toggle = this.querySelector('[data-menu-open]');
          if (!this.dialog || !this.toggle) return;

          this.toggle.addEventListener('click', () => this.open());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-menu-close]')) this.close();
          });
          this.dialog.addEventListener('cancel', () => this.onClosed());
          this.dialog.addEventListener('close', () => this.onClosed());

          this.desktop = window.matchMedia('(min-width: 990px)');
          this.onBreakpoint = (event) => {
            if (event.matches) this.close();
          };
          this.desktop.addEventListener('change', this.onBreakpoint);
        }

        disconnectedCallback() {
          this.desktop?.removeEventListener('change', this.onBreakpoint);
        }

        open() {
          this.dialog.showModal();
          document.documentElement.classList.add('is-scroll-locked');
          this.toggle.setAttribute('aria-expanded', 'true');
        }

        close() {
          if (!this.dialog.open) return;
          this.dialog.close();
          this.onClosed();
        }

        onClosed() {
          document.documentElement.classList.remove('is-scroll-locked');
          if (this.toggle.getAttribute('aria-expanded') === 'false') return;
          this.toggle.setAttribute('aria-expanded', 'false');
          if (this.toggle.checkVisibility()) this.toggle.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pauseForReducedMotion = (root = document) => {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.querySelectorAll('.hero__video').forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
      });
    };
    pauseForReducedMotion();
    document.addEventListener('shopify:section:load', (event) => pauseForReducedMotion(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-hotspots"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pinned = window.matchMedia('(min-width: 1200px) and (prefers-reduced-motion: no-preference)');

    const setup = (root = document) => {
      root.querySelectorAll('.hotspots__pin').forEach((pin) => {
        if (pin.dataset.sequenceReady) return;
        pin.dataset.sequenceReady = 'true';

        const steps = pin.querySelectorAll('.hotspot[data-step]').length;
        const stepEls = [...pin.querySelectorAll('[data-step]')].map((el) => ({ el, step: Number(el.dataset.step), on: null }));
        const slides = [...pin.querySelectorAll('[data-slide]')];
        const labels = [...pin.querySelectorAll('[data-select]')];
        const count = pin.querySelector('[data-count]');
        const fill = pin.querySelector('[data-fill]');
        const live = pin.querySelector('[data-panel-live]');
        let current = 0;
        let lastScrollIndex = 0;
        let lastProgress = 0;
        let leaveTimer;

        const threshold = (step) => ((step + 0.5) / (steps + 0.5)) * 0.85;

        const setActive = (index, announce) => {
          if (index === current || !slides[index]) return;
          const previous = slides[current];
          previous.classList.remove('is-active');
          previous.classList.add('is-leaving');
          clearTimeout(leaveTimer);
          leaveTimer = setTimeout(() => previous.classList.remove('is-leaving'), 520);
          slides[index].classList.remove('is-leaving');
          slides[index].classList.add('is-active');
          labels.forEach((label, i) => label.classList.toggle('is-current', i === index));
          current = index;
          if (count) count.textContent = String(index + 1).padStart(2, '0');
          if (announce && live) {
            const parts = [...slides[index].querySelectorAll('p')].map((p) => p.textContent.trim()).filter(Boolean);
            live.textContent = parts.join(', ');
          }
        };

        const update = (progress) => {
          lastProgress = progress;
          const active = pinned.matches;
          pin.classList.toggle('is-sequenced', active);
          if (!active) return;
          let onCount = 0;
          stepEls.forEach((item) => {
            const on = progress >= threshold(item.step);
            if (on === item.on) return;
            item.on = on;
            item.el.classList.toggle('is-on', on);
          });
          for (let step = 0; step < steps; step += 1) {
            if (progress >= threshold(step)) onCount = step + 1;
          }
          if (fill) fill.style.setProperty('--fill', Math.min(1, progress / 0.85).toFixed(4));
          const index = Math.max(0, onCount - 1);
          if (index !== lastScrollIndex) {
            lastScrollIndex = index;
            setActive(index, true);
          }
        };

        labels.forEach((label) => {
          const select = () => setActive(Number(label.dataset.select), true);
          label.addEventListener('mouseenter', select);
          label.addEventListener('focus', select);
          label.addEventListener('click', select);
        });

        pin.addEventListener('scroll-progress', (event) => update(event.detail));
        pinned.addEventListener('change', () => update(lastProgress));
        update(0);
        window.Ovali?.registerProgress(pin.parentElement);
      });
    };

    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["learn-ingredients"] && !Shopify.designMode) return;
  try {
    
  // Jump links from the rendered ingredients (theme block settings are not
  // readable from the section). Without JS the list simply stays hidden.
  (() => {
    const build = (root = document) => {
      root.querySelectorAll('[data-learn-index]').forEach((nav) => {
        const section = nav.closest('.learn');
        const list = nav.querySelector('[data-learn-index-list]');
        const items = [...section.querySelectorAll('.research[id]')];
        list.textContent = '';
        items.forEach((item) => {
          const name = item.querySelector('.research__name')?.textContent.trim();
          if (!name) return;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'learn__index-link';
          a.href = `#${item.id}`;
          a.textContent = name;
          li.appendChild(a);
          list.appendChild(li);
        });
        nav.hidden = list.children.length < 2;
      });
    };
    build();
    document.addEventListener('shopify:section:load', (event) => build(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.counter = this.querySelector('[data-current]');
          if (this.slides.length < 2 || !('IntersectionObserver' in window)) return;

          // The active slide comes from an observer on the track, so swiping
          // never reads layout; it only matters on mobile, where the dots show.
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.slide));
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));

          this.dots.forEach((dot) =>
            dot.addEventListener('click', () => {
              const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              this.track.scrollTo({ left: Number(dot.dataset.dot) * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
            })
          );
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        setActive(index) {
          if (index === this.active) return;
          this.active = index;
          this.dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === index));
          this.dots[index]?.setAttribute('aria-current', 'true');
          if (this.counter) this.counter.textContent = String(index + 1);
        }
      }
    );
  }

  if (!customElements.get('main-product')) {
    customElements.define(
      'main-product',
      class MainProduct extends HTMLElement {
        connectedCallback() {
          this.info = this.querySelector('[data-info]');
          this.header = document.querySelector('.section-header');
          this.desktop = window.matchMedia('(min-width: 990px)');
          if (!this.info || !('ResizeObserver' in window)) return;

          // Sticky offset: under the header when the column fits the viewport;
          // when it is taller, it scrolls until its bottom shows, then sticks.
          // Measured on resize only (column, header, viewport), never on scroll.
          this.measure = () => {
            this.frame = 0;
            if (!this.desktop.matches) return;
            const headerBottom = this.header ? this.header.getBoundingClientRect().height : 0;
            const gap = 24;
            const top = Math.min(headerBottom + gap, window.innerHeight - this.info.offsetHeight - gap);
            this.style.setProperty('--sticky-top', `${Math.round(top)}px`);
          };
          this.request = () => {
            if (!this.frame) this.frame = requestAnimationFrame(this.measure);
          };
          this.resizeObserver = new ResizeObserver(this.request);
          this.resizeObserver.observe(this.info);
          if (this.header) this.resizeObserver.observe(this.header);
          window.addEventListener('resize', this.request, { passive: true });
          this.request();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          window.removeEventListener('resize', this.request);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    // A wrong store password reloads the page with an error: put the cursor back in the field.
    if (document.getElementById('PasswordError')) {
      document.getElementById('PasswordInput')?.focus();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ease = (t) => 1 - Math.pow(1 - t, 3);

    const split = (el) => {
      if (reduced.matches || el.classList.contains('is-split')) return;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      let index = 0;
      nodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/([ \t\n\r]+)/).forEach((part) => {
          if (!part) return;
          if (/^[ \t\n\r]+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }
          const word = document.createElement('span');
          word.className = 'word';
          word.style.setProperty('--i', index);
          word.textContent = part;
          fragment.appendChild(word);
          index += 1;
        });
        node.replaceWith(fragment);
      });

      el.style.setProperty('--n', Math.max(index - 1, 1));
      el.classList.add('is-split');
    };

    const setup = (root = document) => {
      root.querySelectorAll('.statement').forEach((section) => {
        if (section.dataset.statementReady) return;
        section.dataset.statementReady = 'true';

        const text = section.querySelector('[data-word-reveal]');
        if (!text) return;
        split(text);

        const words = [...text.querySelectorAll('.word')];
        const sprigs = [...section.querySelectorAll('[data-sprig]')];
        const motions = sprigs.map((sprig) => sprig.querySelector('.statement__sprig-motion'));
        const directions = sprigs.map((sprig) => (sprig.classList.contains('statement__sprig--left') ? -1 : 1));
        const usesTimeline = CSS.supports('animation-timeline: view()');
        let progress = 0;
        let sprigWidths = sprigs.map(() => 0);

        // Writes transform and opacity directly (custom properties would
        // restyle every path in the sprig). Widths are cached by guard(),
        // so a scroll frame never reads layout.
        let lastArrive = -1;
        const cssMotion = () => usesTimeline && desktop.matches && !reduced.matches;
        const applyMotion = (force) => {
          // CSS scroll-driven animation handles it; clear any JS styles once.
          if (cssMotion()) {
            if (lastArrive !== -2) motions.forEach((motion) => { motion.style.transform = ''; motion.style.opacity = ''; });
            lastArrive = -2;
            return;
          }
          const animate = desktop.matches && !reduced.matches;
          const arrive = animate ? ease(Math.min(1, Math.max(0, (progress - 0.1) / 0.45))) : 1;
          if (!force && Math.abs(arrive - lastArrive) < 0.001) return;
          lastArrive = arrive;
          sprigs.forEach((sprig, i) => {
            const motion = motions[i];
            const direction = directions[i];
            const distance = sprigWidths[i] * 1.1;
            motion.style.transform = `translate3d(${(direction * distance * (1 - arrive)).toFixed(1)}px, 0, 0) rotate(${(direction * -9 * (1 - arrive)).toFixed(2)}deg)`;
            motion.style.opacity = (0.15 + 0.85 * arrive).toFixed(3);
          });
        };

        const guard = () => {
          const gap = 24;
          sprigWidths = sprigs.map((sprig) => sprig.offsetWidth);
          sprigs.forEach((sprig) => {
            const motion = sprig.querySelector('.statement__sprig-motion');
            const reveal = sprig.querySelector('.statement__sprig-reveal');
            const saved = motion.style.transform;
            reveal.style.transition = 'none';
            reveal.style.transform = 'none';
            motion.style.animation = 'none';
            motion.style.transform = 'none';
            sprig.style.setProperty('--guard', '0px');
            sprig.removeAttribute('data-hidden');

            const art = sprig.querySelector('svg').getBoundingClientRect();
            const box = text.getBoundingClientRect();
            const sectionBox = section.getBoundingClientRect();
            const isLeft = sprig.classList.contains('statement__sprig--left');
            const overlapsY = art.bottom > box.top - gap && art.top < box.bottom + gap;
            let shift = 0;
            if (overlapsY) {
              if (isLeft && art.right > box.left - gap) shift = (box.left - gap) - art.right;
              if (!isLeft && art.left < box.right + gap) shift = (box.right + gap) - art.left;
            }
            sprig.style.setProperty('--guard', `${shift.toFixed(1)}px`);

            const visibleLeft = Math.max(art.left + shift, sectionBox.left);
            const visibleRight = Math.min(art.right + shift, sectionBox.right);
            if (visibleRight - visibleLeft < art.width * 0.2) sprig.setAttribute('data-hidden', '');

            motion.style.transform = saved;
            motion.style.animation = '';
            reveal.style.transform = '';
            void reveal.offsetWidth;
            reveal.style.transition = '';
          });
        };

        if (sprigs.length) {
          guard();
          applyMotion(true);
          let resizeTimer;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
              guard();
              applyMotion(true);
            }, 120);
          });
          if (document.fonts?.ready) document.fonts.ready.then(() => {
            guard();
            applyMotion(true);
          });
          desktop.addEventListener('change', () => {
            guard();
            applyMotion(true);
          });
        }

        section.addEventListener('scroll-progress', (event) => {
          progress = event.detail;
          if (sprigs.length) applyMotion();
          if (!usesTimeline) {
            words.forEach((word, i) => {
              const start = 0.18 + (i / Math.max(words.length - 1, 1)) * 0.34;
              word.classList.toggle('is-on', progress >= start + 0.05);
            });
          }
        });
        window.Ovali?.registerProgress(section.parentElement);
      });
    };

    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
